import { TSimpleI18nTranslations } from "@ldp/simple-i18n";

/**
 * This is a temporary solution to provide translations while the BFF solution is being developed.
 * This will be removed once the BFF solution is in place.
 * https://jira.lblw.cloud/browse/LDP-8460 to track the progress of the tech-debt.
 */

export const translations: TSimpleI18nTranslations = {
  en: {
    skip: "skip",
    a11ySection: "this section",
    loadMore: "Load More",
    search: "Search",
    sort: "Sort",
    sortBy: "Sort By:",
    categories: "Categories",
    filters: "Filters",
    clearAll: "Clear All",
    moreFilters: "More filters",
    lessFilters: "Less filters",
    cancelGoBack: "Cancel, go back",
    removeFilters: "Remove Filter",
    showAllResults: "Show All Results",
    showResults: "Show {numberOfFilterResults} Results",
    a11ySkipToFilterSection: "Skip to Filter section",
    a11yAddToCart: "Add {productName} to cart",
    a11yDecreaseQuantity: "Decrease quantity for {productName}",
    a11yIncreaseQuantity: "Increase quantity for {productName}",
    a11yEditQuantity: "{productName} in Cart, edit quantity",
    a11yViewProductDetails: "View Product Details",
    a11yQuantityInCart: "{quantity} {productName} in cart",
    a11yQuantityInCartLabel: "Quantity in cart",
    a11yQuantityLimitReached:
      "Quantity increased to {quantity}. Item limit reached. You cannot add any more {productName}",
    a11yStarRatingLabel: "Rated {rating} out of 5 stars",
    a11yBreadcrumbs: "Breadcrumbs",
    a11yClearSearchTerm: "Clear search term",
    a11yQuickFilters: "Quick filters",
    a11ySelectedFilters: "(filters selected)",
    a11yFilterLegend:
      "filter by {filterGroupName}. Choosing a filter will reload the page with the new results",
    a11yMenuButtonR1: "menu-button-:r1:",
    a11yPageNumber: "Page",
    a11yNextPage: "Next Page",
    a11yPreviousPage: "Previous Page",
    a11ySubmitSearch: "Submit search",
    a11yBanner: "Banners",
    a11yNextSlide: "Next slide",
    a11yPreviousSlide: "Previous slide",
    a11yNextArrow: "Next arrow",
    a11yPreviousArrow: "Previous arrow",
    a11yPagination: "Pagination",
    sponsoredLabel: "Sponsored",
    a11ySliderPrevLabel: "Previous slide",
    a11ySliderNextLabel: "Next slide",
    a11ySliderFirstLabel: "Go to first slide",
    a11ySliderLastLabel: "Go to last slide",
    a11ySlideXLabel: "Go to slide %s",
    a11ySlideLabel: "slide %s",
    a11ySliderSelectLabel: "Select a slide to show",
    close: "Close",
    a11yClearSearchLabel: "clear Search",
    a11yMegaMenuExploreMessage: "Press Right Arrow key to explore links.",
    a11yMegaMenuAriaLabel: "Main navigation",
    megaMenuCloseLabel: "Close",
    ariaLabelOpenMenu: "Open Menu",
    requiredInputFieldError: "Error: This field is required.",
    nameFieldValidationError:
      "Error: You have entered numbers or special characters.",
    emailFieldValidationError: "Error: Please enter a valid email address.",
    inputFieldValidationError: "Error: Invalid characters.",
    nameMaxLengthError: "Error: You can only enter up to 60 characters.",
    zeroResultsFound: "results are found.",
    formSuccessAlertHeader: "Your inquiry has been submitted!",
    formSuccessAlertBody:
      "Thank you for reaching out to us. Our customer service team will get in touch with you as soon as possible.",
    formErrorAlertHeader: "Something went wrong.",
    formErrorAlertBody: "Your submission wasn't successful. Please try again!",
    pcoAlertHeader: "Need help with PC Optimum offers & points?",
    pcoAlertBody:
      "Please visit us at [PCOptimum.ca](https://www.pcoptimum.ca/) to submit your inquiry.",
    pcoDropdownValue: "PC Optimum™",
    signUpSuccessAlertHeader: "Signed up successfully",
    signUpSuccessAlertBody:
      "Thanks for joining! Look out for your first offer of 10,000 PC Optimum™ points.",
    signUpSubmitErrorHeader: "Sorry, something went wrong on our end.",
    signUpSubmitErrorBody: "Your sign up wasn’t successful. Please try again!",
    emailValidationError: "Invalid email format. Try again!",
    emailSignUpRequiredInputError: "Please enter an email address to sign up.",
    phoneValidationError: "Please enter a valid phone number.",
    phoneSignUpRequiredInputError: "Please enter a phone number to sign up.",
  },
  fr: {
    skip: "sauter",
    a11ySection: "cette section",
    loadMore: "Charger plus d'articles",
    search: "Recherche",
    sort: "Trier",
    sortBy: "Trier par:",
    categories: "Catégories",
    filters: "Filtres",
    clearAll: "Effacer tout",
    moreFilters: "Plus de filtres",
    lessFilters: "Moins de filtres",
    cancelGoBack: "Annuler",
    removeFilters: "Retirer les filtre",
    showAllResults: "Voir tous les résultats",
    showResults: "Afficher {numberOfFilterResults} résultats",
    a11ySkipToFilterSection: "Passer au filtrage du contenu",
    a11yAddToCart: "Ajouter {productName} au panier",
    a11yDecreaseQuantity: "Diminuer la quantité pour {productName}",
    a11yIncreaseQuantity: "Augmenter la quantité pour {productName}",
    a11yEditQuantity: "{productName} dans le panier, modifier la quantité",
    a11yViewProductDetails: "Voir les détails du produit",
    a11yQuantityInCart: "{quantity} {productName} dans le panier",
    a11yQuantityInCartLabel: "Quantité dans le panier",
    a11yQuantityLimitReached:
      "Quantité augmentée à {quantity}. Limite d'articles atteinte. Vous ne pouvez pas ajouter plus de {productName}",
    a11yStarRatingLabel: "Score de {rating} sur 5 étoiles",
    a11yBreadcrumbs: "Piste de navigation",
    a11yClearSearchTerm: "Effacer le terme de recherche",
    a11yQuickFilters: "Filtres rapides",
    a11ySelectedFilters: "(filtres sélectionnés)",
    a11yFilterLegend:
      "filtrer par {filterGroupName}. Le choix d'un filtre rechargera la page avec les nouveaux résultats",
    a11yMenuButtonR1: "bouton-de-menu-:r1:",
    a11yPageNumber: "Page",
    a11yNextPage: "Page suivante",
    a11yPreviousPage: "Page précédente",
    a11ySubmitSearch: "Soumettre la recherche",
    a11yNextSlide: "Prochaine diapositive",
    a11yPreviousSlide: "Diapositive précédente",
    a11yBanner: "Bannières",
    a11yNextArrow: "Flèche suivante",
    a11yPreviousArrow: "Flèche précédente",
    a11yPagination: "Pagination",
    sponsoredLabel: "Sponsorisé",
    a11ySliderPrevLabel: "diapositive précédente",
    a11ySliderNextLabel: "diapositive suivante",
    a11ySliderFirstLabel: "aller à la première diapositive",
    a11ySliderLastLabel: "aller à la dernière diapositive",
    a11ySlideXLabel: "aller à la diapositive %s",
    a11ySlideLabel: "diapositive",
    a11ySliderSelectLabel: "sélectionner une diapositive à montrer",
    close: "Fermer",
    a11yClearSearchLabel: "Effacer la recherche",
    a11yMegaMenuExploreMessage:
      "Appuyez sur la touche Flèche droite pour explorer les liens.",
    megaMenuCloseLabel: "Fermer",
    a11yMegaMenuAriaLabel: "Navigation principale",
    ariaLabelOpenMenu: "Ouvrir le menu",
    requiredInputFieldError: "Erreur : Ce champ est obligatoire.",
    nameFieldValidationError:
      "Erreur : Vous avez saisi des chiffres ou des caractères spéciaux.",
    emailFieldValidationError:
      "Erreur : Veuillez fournir une adresse courriel valide.",
    inputFieldValidationError: "Erreur : Caractères non valides.",
    nameMaxLengthError:
      "Erreur : Vous ne pouvez pas saisir plus de 60 caractères.",
    zeroResultsFound: "les résultats sont trouvés.",
    formSuccessAlertHeader: "Votre question a été soumise!",
    formSuccessAlertBody:
      "Merci de nous avoir contactés. Notre équipe de service à la clientèle communiquera avec vous dès que possible.",
    formErrorAlertHeader: "Un problème est survenu.",
    formErrorAlertBody: "Votre demande a échoué. Veuillez réessayer!",
    pcoAlertHeader: "Besoin d'aide avec les offres et les points PC Optimum ?",
    pcoAlertBody:
      "Visitez notre site à [PCOptimum.ca](https://www.pcoptimum.ca/) pour soumettre votre demande.",
    pcoDropdownValue: "PC Optimum🅪",
    signUpSuccessAlertHeader: "Inscription réussie",
    signUpSuccessAlertBody:
      "Merci de vous être inscrit au bulletin! Restez à l’affût de votre première offre de 10 000 points PC Optimum🅪.",
    signUpSubmitErrorHeader: "Désolé, une erreur s’est produite de notre côté.",
    signUpSubmitErrorBody:
      "Votre inscription n’a pas réussi. Veuillez réessayer!",
    emailValidationError:
      "Format d’adresse courriel non valide. Veuillez réessayer!",
    emailSignUpRequiredInputError:
      "Veuillez entrer une adresse courriel pour vous inscrire.",
    phoneValidationError: "Veuillez entrer un numéro de téléphone valide.",
    phoneSignUpRequiredInputError:
      "Veuillez entrer un numéro de téléphone pour vous inscrire.",
  },
};
